import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "pages/login"
import Register from "pages/login/Register"
import ThankYou from "pages/login/ThankYou"
import ResetPassword from "pages/login/ResetPass"
import PasswordReseted from "pages/login/PasswordReseted"
import CreateShop from "pages/login/CreateShop"
import SelectTemplate from "pages/login/SelectTemplate"
const PageRoutes = () => {
  return (
    <Routes>

      <Route path="/register" element={<CreateShop></CreateShop>} />\
      <Route path="/thank-you" element={<ThankYou></ThankYou>} />
      <Route path="/reset-password" element={<ResetPassword></ResetPassword>} />
      <Route path="/passreseted" element={<PasswordReseted></PasswordReseted>} />
      <Route path="/shop-template" element={<SelectTemplate></SelectTemplate>} />
       <Route path="/shop-create" element={<CreateShop></CreateShop>} />
      <Route path="*" element={<LoginPage></LoginPage>} />
    </Routes>
  );
};

export default React.memo(PageRoutes);
